// extracted by mini-css-extract-plugin
module.exports = {"root":"handleToTop_root__jZX_o"};